import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SuccessModal = ({ isOpen, orderNumber, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleTrackOrder = () => {
    navigate('/order-status-tracking');
  };

  const handleGoHome = () => {
    navigate('/customer-home');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md rounded-lg bg-card p-6 shadow-card">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-success/10">
            <Icon name="CheckCircle2" size={32} color="var(--color-success)" />
          </div>
          <h2 className="mb-2 text-2xl font-bold text-foreground">주문이 완료되었습니다!</h2>
          <p className="text-sm text-muted-foreground">
            주문번호: <span className="font-semibold text-foreground">{orderNumber}</span>
          </p>
        </div>
        <div className="mb-6 rounded-lg bg-muted/30 p-4">
          <div className="mb-2 flex items-start space-x-2">
            <Icon name="Info" size={16} color="var(--color-accent)" className="mt-0.5" />
            <p className="text-sm text-foreground">
              카카오톡으로 주문 확인 메시지가 발송됩니다.
            </p>
          </div>
          <div className="flex items-start space-x-2">
            <Icon name="Truck" size={16} color="var(--color-accent)" className="mt-0.5" />
            <p className="text-sm text-foreground">
              픽업은 영업일 기준 1-2일 내에 진행됩니다.
            </p>
          </div>
        </div>
        <div className="space-y-3">
          <Button variant="default" fullWidth onClick={handleTrackOrder}>
            주문 조회하기
          </Button>
          <Button variant="outline" fullWidth onClick={handleGoHome}>
            홈으로 돌아가기
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;